import { ModelPath } from "@com.mgmtp.a12.base/base-model-api/lib/main/model";
import { EntityInstancePath } from "@com.mgmtp.a12.kernel/kernel-md-facade";

/**
 * The path to the text of a node in the Textbaustein tree.
 */
export const PATH_TO_NODE_TEXT: EntityInstancePath = [
	{ elementName: "root", index: 1 },
	{ elementName: "text", index: 1 }
];

/**
 * The path to the marker of a Verfahren or a Kategorie_Readonly node.
 */
export const PATH_TO_MARKER: EntityInstancePath = [
	{ elementName: "root", index: 1 },
	{ elementName: "marker", index: 1 }
];

export const PATH_TO_GENEHMIGUNGSVERFAHREN: ModelPath = [
	{ elementName: "root" },
	{ elementName: "genehmigungsverfahren" }
];

export const PATH_TO_STATUS = [
	...PATH_TO_GENEHMIGUNGSVERFAHREN,
	{ elementName: "prozessschritte" },
	{ elementName: "Status" }
];

export const PATH_TO_VALIDATION_TYP: ModelPath = [
	...PATH_TO_GENEHMIGUNGSVERFAHREN,
	{ elementName: "prozessschritte" },
	{ elementName: "validationTyp" }
];

export const MODEL_PATH_TO_STATUS = "/root/genehmigungsverfahren/prozessschritte/Status";
export const QUERY_PATH_TO_STATUS = "root.genehmigungsverfahren.prozessschritte.Status";

export const PATH_TO_ERSTELLT_IN_VERSION: ModelPath = [
	{ elementName: "root" },
	{ elementName: "processMetadata" },
	{ elementName: "fachverfahren" },
	{ elementName: "erstelltInVersion" }
];
export const QUERY_PATH_TO_ERSTELLT_IN_VERSION = "/root/processMetadata/fachverfahren/erstelltInVersion";

export const QUERY_PATH_TO_VALIDATION_TYP = "root.genehmigungsverfahren.prozessschritte.validationTyp";

export const PATH_TO_ARCHIVAL_IN_PROGRESS: ModelPath = [
	{ elementName: "root" },
	{ elementName: "processMetadata" },
	{ elementName: "archival" },
	{ elementName: "archivalInProgress" }
];

export const PATH_TO_ASSIGNEE_GROUP: ModelPath = [
	{ elementName: "root" },
	{ elementName: "processMetadata" },
	{ elementName: "task" },
	{ elementName: "assignee" }
];

export const QUERY_PATH_TO_ASSIGNEE_ID = "root.processMetadata.task.assignee.id";
export const QUERY_PATH_TO_ASSIGNEE_FULL_NAME = "/root/processMetadata/task/assignee/id";
export const PATH_TO_ASSIGNEE_FULL_NAME: ModelPath = [
	{ elementName: "root" },
	{ elementName: "processMetadata" },
	{ elementName: "task" },
	{ elementName: "assignee" },
	{ elementName: "id" }
];

export const PATH_TO_STAMMDATEN_ASSIGNEE_GROUP: ModelPath = [
	{ elementName: "root" },
	{ elementName: "stammdatenDefault" },
	{ elementName: "assignee" }
];

export const QUERY_PATH_TO_STAMMDATEN_ASSIGNEE_ID = "root.stammdatenDefault.assignee.id";
export const QUERY_PATH_TO_STAMMDATEN_ASSIGNEE_FULL_NAME = "root.stammdatenDefault.assignee.fullName";
export const PATH_TO_STAMMDATEN_ASSIGNEE_FULL_NAME: ModelPath = [
	{ elementName: "root" },
	{ elementName: "stammdatenDefault" },
	{ elementName: "assignee" },
	{ elementName: "fullName" }
];
